export default "__VITE_ASSET__B6GEGWS8__"